import { nearestCity } from "./home/sceneModel";

// Asks the browser for the viewer's position and turns it into a tracked city
// key (the usPlaces CITY_COORDS table). Shared by the homepage's city chip
// (home/useHomeCity.js) and sign-up's "Use my current location", so both ask
// the same way and say the same thing when it doesn't work. Only the city key
// comes back - the coordinates are never stored or sent anywhere.
//
// Resolves to { key, error }: a key and no error, or no key and a sentence to
// show. It never rejects, so callers don't need a try/catch around it. `hint`
// ends the error with whatever that page offers instead.
export function locateCity({ hint = "Pick a city instead." } = {}) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ key: null, error: `This browser can't share your location.` });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ key: nearestCity(pos.coords.latitude, pos.coords.longitude), error: "" }),
      (err) => resolve({
        key: null,
        error: err && err.code === 1
          ? `Location is blocked for this site. ${hint}`
          : `Couldn't find your location. ${hint}`,
      }),
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 }
    );
  });
}

export default locateCity;
